import { render, staticRenderFns } from "./CreateAppraisal.vue?vue&type=template&id=5f75dc86&"
import script from "./CreateAppraisal.vue?vue&type=script&lang=js&"
export * from "./CreateAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports